import React, { Fragment } from 'react';
import i18n from 'i18next';
import { useForm } from '@inertiajs/inertia-react';
import '@inertiajs/inertia-react';
import Button from '@/Components/Button';
import ValidationErrors from '@/Components/ValidationErrors';
import {FormInput, FormInputCountrySelector} from "@/Components/Controls";

export default function MyBillingSlider({show, organization, toggleMyBilling}) {
    const { data, setData, post, processing, errors } = useForm({
        organization_name: organization?.name ?? '',
        address_id: organization?.address?.id ?? '',
        line_1: organization?.address?.line_1 ?? '',
        line_2: organization?.address?.line_2 ?? '',
        city: organization?.address?.city ?? '',
        state: organization?.address?.state ?? '',
        postal_code: organization?.address?.postal_code ?? '',
        country_code: organization?.address?.country_code ?? '',
    });

    const onChange = (event, value) => {
        setData(event, value);
    };

    const onChangeCountryCode = (code) => {
        onChange('country_code', code)
    }

    const save = (e) => {
        e.preventDefault();

        post(route('manage.account-overview.store'), {
            onSuccess: () => {
                toggleMyBilling();
            }
        });
    };

    return (
        <Fragment>
            {show && <div className={"fade modal-backdrop slider-backdrop show"} />}
            <div className={show ? "my-billing slider show" : "my-billing slider"}>
                <div className="slider-header">
                    <div className="slider-title">{i18n.t("my-billing-slider.edit-organization")}</div>
                    <div className="close-slider">
                        <i onClick={() => toggleMyBilling()} className="fa fa-times"></i>
                    </div>
                </div>
                <form onSubmit={save}>
                    <div className="slider-body">
                        {false && <ValidationErrors errors={errors} />}
                        <div className="row">
                            <FormInput error={errors["organization_name"]} name="organization_name" isFocused={true} autoComplete="organization_name" value={data.organization_name} onChange={onChange} label={i18n.t("my-billing-slider.organization-name")} className="col-12" onKeyUp={e => e.keyCode === 13} dataQa="my-billing-organization-name" />
                        </div>
                        <div className="row">
                            <FormInput error={errors["first_name"]} name="first_name" autoComplete="first_name" value={organization?.owner?.first_name ?? ''} label={i18n.t("my-billing-slider.first-name")} className="col-6" onKeyUp={e => e.keyCode === 13} disabled={true} dataQa="my-billing-first-name" />
                            <FormInput error={errors["last_name"]} name="last_name" autoComplete="last_name" value={organization?.owner?.last_name ?? ''} label={i18n.t("my-billing-slider.last-name")} className="col-6" onKeyUp={e => e.keyCode === 13} disabled={true} dataQa="my-billing-last-name" />
                        </div>
                        <div className="row">
                            <FormInput error={errors["line_1"]} name="line_1" autoComplete="address" value={data.line_1} onChange={onChange} label={i18n.t("my-billing-slider.address")} className="col-12" onKeyUp={e => e.keyCode === 13} dataQa="my-billing-address" />
                        </div>
                        <div className="row">
                            <FormInput error={errors["line_2"]} name="line_2" autoComplete="address" value={data.line_2} onChange={onChange} label={i18n.t("my-billing-slider.address2")} className="col-12" onKeyUp={e => e.keyCode === 13} dataQa="my-billing-address-2" />
                        </div>
                        <div className="row">
                            <FormInput error={errors["city"]} name="city" autoComplete="city" value={data.city} onChange={onChange} label={i18n.t("my-billing-slider.city")} className="col-12" onKeyUp={e => e.keyCode === 13} dataQa="my-billing-city" />
                        </div>
                        <div className="row">
                            <FormInput error={errors["state"]} name="state" autoComplete="state" value={data.state} onChange={onChange} label={i18n.t("my-billing-slider.state")} className="col-12" onKeyUp={e => e.keyCode === 13} dataQa="my-billing-state" />
                        </div>
                        <div className="row">
                            <FormInput error={errors["postal_code"]} name="postal_code" autoComplete="zip" value={data.postal_code} onChange={onChange} label={i18n.t("my-billing-slider.zip")} className="col-12" onKeyUp={e => e.keyCode === 13} dataQa="my-billing-zip" />
                        </div>
                        <div className="row">
                            <FormInputCountrySelector
                                error={errors["country_code"]}
                                name="country_code"
                                value={data.country_code}
                                onChange={onChangeCountryCode}
                                label={i18n.t("my-billing-slider.country")}
                                placeholder={i18n.t("my-billing-slider.country")}
                                className="col-12"
                                listMaxHeight={125}
                            ></FormInputCountrySelector>
                        </div>
                        {/*<div className="row">*/}
                        {/*    <FormInput name="credit_card" autoComplete="credit_card" value={data.credit_card} onChange={onChange} label={i18n.t("my-billing-slider.credit-card")} className="col-12" onKeyUp={e => e.keyCode === 13} dataQa="my-billing-credit-card" />*/}
                        {/*</div>*/}
                        {/*<div className="row">*/}
                        {/*    <FormInput name="expiration" autoComplete="expiration" value={data.expiration} onChange={onChange} label={i18n.t("my-billing-slider.expiration")} className="col-sm-9 col-12" onKeyUp={e => e.keyCode === 13} dataQa="my-billing-expiration" />*/}
                        {/*    <FormInput name="ccv" autoComplete="ccv" value={data.ccv} onChange={onChange} label={"CCV"} className="col-sm-3 col-12" onKeyUp={e => e.keyCode === 13} dataQa="my-billing-ccv" />*/}
                        {/*</div>*/}
                    </div>
                    <div className="slider-footer">
                        <Button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => toggleMyBilling()} value="Cancel">
                            {i18n.t("my-billing-slider.cancel")}
                        </Button>
                        <Button type="submit" className="btn btn-sm btn-primary" processing={processing}>
                            {i18n.t("my-billing-slider.save")}
                        </Button>
                    </div>
                </form>
            </div>
        </Fragment>
    );
}
